import { FC, useContext } from 'react';

import { Label } from '@smartshell/ui-kit';
import cn from 'classnames';

import { SubscriptionLabel } from 'components';
import { LocalizationContext } from 'localization';

import s from './ClubCard.module.scss';
import { IClubsProps } from './interfaces';
import { getWorkShiftLabelConfig } from './utils';

export const ClubCard: FC<IClubsProps> = ({
  club,
  selectClub,
  selected,
  isCopySetting,
}) => {
  const { t } = useContext(LocalizationContext);

  return (
    <div
      data-testid={`club-${club.id}`}
      className={cn(
        s.container,
        selected && s.selected,
        !club.permitted && s.disabled,
        isCopySetting && s.isCopySetting
      )}
      onClick={() => {
        if (club.permitted) {
          selectClub(club);
        }
      }}
    >
      {club.workShiftStatus === 'LOCKED' && (
        <Label
          data-testid="club-locked"
          color="red"
          text={t('club.locked')}
          iconName="LockIcon"
        />
      )}
      <Label
        color="gray-primary"
        text={`ID: ${club.id}`}
        rounded
        size="m"
        className={s.id}
      />
      <div className={s.info}>
        <span className={s.title} title={club.name} data-testid="club-name">
          {club.name}
        </span>
        <span
          className={s.address}
          title={club.address}
          data-testid="club-address"
        >
          {club.address}
        </span>
      </div>
      {club.workShiftStatus === 'LOCKED' ? (
        <div className={s.locked} data-testid="club-locked-info">
          <span className={s.header}>{t('clubs.status.free.title')}</span>
          <span>{t('clubs.status.free.description')}</span>
        </div>
      ) : (
        <div className={s.labels}>
          <Label
            dataTestId="workshift-status"
            {...getWorkShiftLabelConfig(club, t)}
            rounded
            size="m"
          />

          <SubscriptionLabel
            clubSubscription={club.tariffName}
            variant="clubCard"
          />
        </div>
      )}
    </div>
  );
};
